/**
 * Turns the validation CODE of a field into the sentence the user reads.
 * `required` is one sentence for every field; `invalid` is specific to what the
 * field holds, so it is looked up by field.
 */
const INVALID_KEY = { email: 'email', domain: 'domain' };

export const fieldErrorText = (t, field, code) => {
  if (!code) return undefined;
  if (code === 'required') return t('create.errors.required');
  return t(`create.errors.${INVALID_KEY[field] ?? 'required'}`);
};
